<div class="filter-date-selection">You are currently viewing data between <span
  class="filter-date-selection-selected">{{startDate | date:'shortDate'}}{{' - '}}{{endDate | date:'shortDate'}}</span>
</div>
